<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/127NiJ6/tc-custom/9781780109213.jpg?1702083418843" alt="This image is the cover for the book River Below"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">River Below
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A tortuous tale of murder and madness . . . a psychological thriller offering insight into love, friendship, and mental illness.”—<i>Kirkus Reviews</i></b></p><p>When a mangled car is pulled from the river, containing bloodstains and a gun, the sense of safety is shattered in Tessa’s Californian hometown. Tessa, who works at the river conservancy, thinks she saw a girl out on the riverbank—but Tessa’s memory is failing and could this be the start of something more serious?<br/><br/> Tessa’s friend and co-worker, Claire Barrett, is worried—about the car and the gun, but also about Tessa. With Tessa’s attorney husband preoccupied with a big case and in denial about his wife’s memory issues, Claire knows that it’ll be up to her to work out what’s going on. When a body turns up and she discovers the identity of the gun’s owner—someone disturbingly close to home—Claire is determined to uncover the truth . . . whatever it takes.</p><p>“This poignant standalone from Hill (<i>Last Words</i>) is as much a story about friendship and loss as it is a mystery . . . A link between Tessa and the murder mystery gradually emerges as this emotionally involving novel builds to a surprising, heart-wrenching climax. Hill’s balanced treatment of environmental issues will resonate with many readers.”—<i>Publishers Weekly</i></p><p>“A haunting psychological thriller.”—<i>Booklist</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bonnie Hearn Hill
      </h2>
      
      <p class="authorDescription body article">Bonnie Hearn Hill was born and raised in Yuba City, California, and worked as a newspaper editor for twenty-two years. She has written several thrillers for adults, as well as numerous short stories, non-fiction books and teen fiction. She now leads a private writers? workshop in Fresno, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a31faa1c